import React from "react";
import AdBanner from "./AdBanner";

const Advertisements = () => {
  return (
    <section className="advertisements">
      <h2>Reklam Alanları</h2>
      <p className="ad-description">
        Uygulamamızda yer alan reklam alanları ile işletmenizi tanıtabilir, 
        hedef kitlenize ulaşabilir ve gelir elde edebilirsiniz.
      </p>
      
      {/* Large Featured Ad */}
      <AdBanner
        imageSrc="./ad_ayfoto.JPG"
        altText="Ayfoto Reklamı"
        companyName="Ayfoto - Fotoğraf Hizmetleri"
        link="#"
      />
      
      <div className="ad-gallery">
        <div className="ad-item">
          <img src="/ad_celenk_gayrimenkul.JPG" alt="Çelenk Gayrimenkul Reklamı" />
          <p>Çelenk Gayrimenkul - Emlak Hizmetleri</p>
        </div>
        <div className="ad-item">
          <img src="/ad_celenk_gayrimenkul2.JPG" alt="Çelenk Gayrimenkul 2 Reklamı" />
          <p>Çelenk Gayrimenkul - Emlak Danışmanlığı</p>
        </div>
        <div className="ad-item">
          <img src="/ad_simge_bilgisayar.JPG" alt="Simge Bilgisayar Reklamı" />
          <p>Simge Bilgisayar - Teknoloji Çözümleri</p>
        </div>
      </div>
    </section>
  );
};

export default Advertisements;
